export type EncodedBrainImage = {
  mediaBase64: string
  mediaMimeType: string
}

export function validateBrainImage(file: File, allowedMimeTypes: string[], maximumBytes: number) {
  if (!allowedMimeTypes.includes(file.type)) {
    throw new Error(`Formato não permitido. Use ${allowedMimeTypes.join(', ')}.`)
  }
  if (file.size < 1 || file.size > maximumBytes) {
    throw new Error(`A imagem deve ter até ${formatBytes(maximumBytes)}.`)
  }
}

export async function encodeBrainImage(file: File, allowedMimeTypes: string[], maximumBytes: number): Promise<EncodedBrainImage> {
  validateBrainImage(file, allowedMimeTypes, maximumBytes)
  const dataUrl = await readFileAsDataURL(file)
  const separator = dataUrl.indexOf(',')
  if (separator < 0) throw new Error('Não foi possível preparar a imagem para o laboratório.')
  return { mediaBase64: dataUrl.slice(separator + 1), mediaMimeType: file.type }
}

function readFileAsDataURL(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => reject(new Error('Não foi possível ler a imagem selecionada.'))
    reader.onload = () => typeof reader.result === 'string' ? resolve(reader.result) : reject(new Error('Conteúdo de imagem inválido.'))
    reader.readAsDataURL(file)
  })
}

function formatBytes(value: number) {
  if (value >= 1024 * 1024) return `${Math.floor(value / (1024 * 1024))} MB`
  return `${Math.floor(value / 1024)} KB`
}
